import CryptoJS from 'crypto-js';

const SECRET_KEY = "das982ndjsadjni82h38h2dmksajd"; // store securely in .env

export const encryptValue = (value) => {
  const stringData = typeof value === 'string' ? value : JSON.stringify(value);
  return CryptoJS.AES.encrypt(stringData, SECRET_KEY).toString();
};

export const decryptValue = (encrypted) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  } catch (err) {
    return null;
  }
};

export const setEncryptedItem = (key, value) => {
  const encryptedValue = encryptValue(value);
  localStorage.setItem(key, encryptedValue);
};

export const getEncryptedItem = (key) => {
  const encryptedValue = localStorage.getItem(key);
  return encryptedValue ? decryptValue(encryptedValue) : null;
};
